module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/stronghold_bg_with_news_with_quests_big.4e12a0f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/stronghold_bg_with_news_with_quests_big.jpg
// module id = 3037
// module chunks = 11